import React from 'react';
import {Link} from 'react-router';
import Price from "./Price";
import {getResourceImageUrl} from "../actions/networkActions";
import ImageWithFallback from "./ImageWithFallback";
import { useLingui } from '@lingui/react/macro';
import { getTranslation } from '../utils/translationUtils';

function RecommendationEntry(props) {
    const {recommendation: {excursion, itinerary}} = props;
    const {t} = useLingui();

    return (
        <div className="rec-card h-full">
            <div className="w-rec bg-white mx-auto h-full flex flex-col">
                <div>
                    <ImageWithFallback
                        className="w-rec h-rec cover-fit"
                        alt={excursion.name.defaultValue}
                        src={getResourceImageUrl(excursion.id, {width: 250, category:"cruiseExcursion"})}
                    />
                </div>
                <div className="p-2 flex flex-col grow">
                    <Link className="text-primary underline text-lg uppercase"
                          to={ t({id: "/excursion"}) + `/${itinerary.id}/${excursion.id}`}>
                        {getTranslation(excursion.name)}
                    </Link>
                    <div className="mt-2 pb-2 text-lg border-b uppercase">
                        {getTranslation(excursion.port.name)}
                    </div>
                    <div className="mt-auto">
                        <Price 
                            preText={t({id: "from"})} 
                            price={excursion.price.adult} 
                            postText={t({id: "pp"})} largePostText={true} 
                            currencySymbol={excursion.price.currencySymbol}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RecommendationEntry;
